const sectionCode = "SPRO2";
const chartCode = "C052x";

import { Procedures } from "modules/provider/shared/procedure-charts";

function T52Procedures() {
  return <Procedures chartCode={chartCode} sectionCode={sectionCode} />;
}

export { T52Procedures };
